<template>
  <v-app>
    <v-main>
      <vue-page-transition>
        <router-view></router-view>
      </vue-page-transition>
    </v-main>
    <v-fab-transition>
      <a href="tel:02146888418">
        <v-btn aria-label="تماس با رادیولوژی"
               bottom
               class="black--text mb-3 ml-3  mb-n1 ml-n1"
               color="success"
               elevation="0"
               fab
               fixed
               large
               left>
          <i class="fa-solid fa-phone white--text font-26"></i>
        </v-btn>
      </a>
    </v-fab-transition>
  </v-app>
</template>

<script>
import {SITE_NAME} from "@/seo";

export default {
  name: "App",
  components: {},
  metaInfo: {
    titleTemplate: "%s | " + SITE_NAME,
    htmlAttrs: {lang: "fa", dir: "rtl"},
  },
  data: () => ({
    //
  }),
  methods: {
    top () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  }
};
</script>
